import { useEffect } from 'react';
import { useCookieConsent } from './useCookieConsent';

declare global {
  interface Window {
    gtag: (...args: unknown[]) => void;
  }
}

/**
 * Consent-mode-only hook for GTM.
 * Updates analytics_storage / ad_storage consent signals.
 * All event tracking is handled via src/lib/tracking.ts (dataLayer pushes).
 */
export function useGoogleAnalytics() {
  const { preferences } = useCookieConsent();

  useEffect(() => {
    if (!window.gtag) return;

    window.gtag('consent', 'update', {
      'analytics_storage': preferences.analytics ? 'granted' : 'denied',
    });
  }, [preferences.analytics]);

  useEffect(() => {
    if (!window.gtag) return;

    window.gtag('consent', 'update', {
      'ad_storage': preferences.marketing ? 'granted' : 'denied',
      'ad_user_data': preferences.marketing ? 'granted' : 'denied',
      'ad_personalization': preferences.marketing ? 'granted' : 'denied',
    });
  }, [preferences.marketing]);
}
